
export default {
	props: {
		slide: {
			type: Boolean,
			default: false
		}
	}
}
